export const prerender = true;
export const ssr = true;
export const trailingSlash = "always";

// Pass the +layout.server.js data through. With both a server and a
// universal load at this level, SvelteKit makes the server load's output the
// universal load's `data` argument and does NOT merge it automatically - the
// universal load's return value is what the component receives. Returning an
// empty object here silently dropped every server field (country,
// environment, distinctId, featureFlags, experimentVariants, abVariant,
// requiresCookieConsent, trackingParams), which broke the client-side
// experiment bootstrap and left client analytics events untagged. (The
// server-side event mirror reads `locals` directly, so it was unaffected -
// which is why this stayed hidden.)
export async function load({ data }) {
  return data;
}
